import RecapAttendanceActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  helperRecapAttendance:null,
  timeline:null,
  details:null,
  loadingDetails:false
};

function RecapAttendanceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RecapAttendanceActions.RESET_DATA:
      return INITIAL_STATE;
    case RecapAttendanceActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case RecapAttendanceActions.GET_HELPER_RECAPATTENDANCE:
        return { 
          ...state,
          isProcessing: false, 
          helperRecapAttendance: action.payload 
        };
      case RecapAttendanceActions.GET_DATA:
        return { 
          ...state,
          isProcessing: true, 
      };
      case RecapAttendanceActions.SET_TRACKING:
        return { 
          ...state,
          isProcessing: false, 
          timeline: action.payload 
        };
      case RecapAttendanceActions.LOADED_DETAILS:
        return { 
          ...state,
          details: action.payload, 
          loadingDetails: false
        };
      case RecapAttendanceActions.LOADING_DETAILS:
        return { 
          ...state,
          details: null, 
          loadingDetails: true
        };
    default:
      return state;
    }
}


export default RecapAttendanceReducer;
